export default {"src":"/_next/static/media/ollie-logo-lilac.b901e915.svg","height":37,"width":76,"blurWidth":0,"blurHeight":0};